/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum that defines all possible filter types.
 */
export var FilterType;
(function (FilterType) {
    FilterType["BOOLEAN_EQUALS"] = "booleanEquals";
    FilterType["BOUNDING_BOX"] = "boundingBox";
    FilterType["CONTAINS"] = "contains";
    FilterType["ENDS_WITH"] = "endsWith";
    FilterType["FLOAT_EQUALS"] = "floatEquals";
    FilterType["FLOAT_RANGE"] = "floatRange";
    FilterType["GEO_BOUNDARY"] = "geoBoundary";
    FilterType["GROUP_FILTER"] = "groupFilter";
    FilterType["INTEGER_EQUALS"] = "integerEquals";
    FilterType["INTEGER_RANGE"] = "integerRange";
    FilterType["POINT_AND_RADIUS"] = "pointAndRadius";
    FilterType["STARTS_WITH"] = "startsWith";
    FilterType["STRING_EQUALS"] = "stringEquals";
    FilterType["TIME_RANGE"] = "timeRange";
    FilterType["IS_NULL"] = "isNull";
})(FilterType || (FilterType = {}));
